module.exports = __webpack_public_path__ + "static/media/logo~vXxsgZKH.6f60cebe.svg";